import app from 'flarum/app';
import NewTagsModal from '../components/NewTagsModal';
import {extend} from 'flarum/extend';
import Page from 'flarum/components/Page';
import Model from 'flarum/Model';
import User from "flarum/models/User";

export default function () {
  app.store.models.tags.prototype.isPreferred = Model.attribute('isPreferred');
  app.store.models.tags.prototype.isForcedPreferred = Model.attribute('isForcedPreferred');
  User.prototype.skippedPreferredModal = Model.attribute('skippedPreferredModal');

  extend(Page.prototype, 'oninit', function () {

    if (!app.session.user) {
      return;
    }

    if (!sessionStorage.getItem('preferred_skip_check')) {
      const tags = app.store.all('tags');
      // filter out a list of tags where isPreferred is null,
      // meaning they are new and have not yet been considered by the user
      const newTags = tags.filter(t => {
        return t.isPreferred() === null && !t.data.attributes.isChild && t.position() !== null;
      });
      if (newTags.length > 0) {
        setTimeout(() => {
          app.modal.show(NewTagsModal, {});
        });
      }
    }
  });
}
